@file:OptIn(InternalResourceApi::class)

package studio.oddpods.cauce.feature.settings.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String =
    "composeResources/studio.oddpods.cauce.feature.settings.generated.resources/"

internal val Res.string.feature_settings_account_title: StringResource by lazy {
      StringResource("string:feature_settings_account_title", "feature_settings_account_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 46),
      ))
    }

internal val Res.string.feature_settings_brand_android: StringResource by lazy {
      StringResource("string:feature_settings_brand_android", "feature_settings_brand_android", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 57, 50),
      ))
    }

internal val Res.string.feature_settings_brand_default: StringResource by lazy {
      StringResource("string:feature_settings_brand_default", "feature_settings_brand_default", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 108, 58),
      ))
    }

internal val Res.string.feature_settings_brand_guidelines: StringResource by lazy {
      StringResource("string:feature_settings_brand_guidelines", "feature_settings_brand_guidelines", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 167, 69),
      ))
    }

internal val Res.string.feature_settings_change_theme_placeholder_text: StringResource by lazy {
      StringResource("string:feature_settings_change_theme_placeholder_text", "feature_settings_change_theme_placeholder_text", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 237, 70),
      ))
    }

internal val Res.string.feature_settings_change_theme_text: StringResource by lazy {
      StringResource("string:feature_settings_change_theme_text", "feature_settings_change_theme_text", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 308, 58),
      ))
    }

internal val Res.string.feature_settings_dark_mode_config_dark: StringResource by lazy {
      StringResource("string:feature_settings_dark_mode_config_dark", "feature_settings_dark_mode_config_dark", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 367, 54),
      ))
    }

internal val Res.string.feature_settings_dark_mode_config_light: StringResource by lazy {
      StringResource("string:feature_settings_dark_mode_config_light", "feature_settings_dark_mode_config_light", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 422, 55),
      ))
    }

internal val Res.string.feature_settings_dark_mode_config_system_default: StringResource by lazy {
      StringResource("string:feature_settings_dark_mode_config_system_default", "feature_settings_dark_mode_config_system_default", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 478, 92),
      ))
    }

internal val Res.string.feature_settings_dark_mode_preference: StringResource by lazy {
      StringResource("string:feature_settings_dark_mode_preference", "feature_settings_dark_mode_preference", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 571, 81),
      ))
    }

internal val Res.string.feature_settings_date_format: StringResource by lazy {
      StringResource("string:feature_settings_date_format", "feature_settings_date_format", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 840, 60),
      ))
    }

internal val Res.string.feature_settings_date_format_dmy_dash: StringResource by lazy {
      StringResource("string:feature_settings_date_format_dmy_dash", "feature_settings_date_format_dmy_dash", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 653, 61),
      ))
    }

internal val Res.string.feature_settings_date_format_dmy_slash: StringResource by lazy {
      StringResource("string:feature_settings_date_format_dmy_slash", "feature_settings_date_format_dmy_slash", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 715, 62),
      ))
    }

internal val Res.string.feature_settings_date_format_ymd_dash: StringResource by lazy {
      StringResource("string:feature_settings_date_format_ymd_dash", "feature_settings_date_format_ymd_dash", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 778, 61),
      ))
    }

internal val Res.string.feature_settings_dismiss_dialog_button_text: StringResource by lazy {
      StringResource("string:feature_settings_dismiss_dialog_button_text", "feature_settings_dismiss_dialog_button_text", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 901, 55),
      ))
    }

internal val Res.string.feature_settings_display_title: StringResource by lazy {
      StringResource("string:feature_settings_display_title", "feature_settings_display_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 957, 58),
      ))
    }

internal val Res.string.feature_settings_dynamic_color_no: StringResource by lazy {
      StringResource("string:feature_settings_dynamic_color_no", "feature_settings_dynamic_color_no", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1016, 45),
      ))
    }

internal val Res.string.feature_settings_dynamic_color_preference: StringResource by lazy {
      StringResource("string:feature_settings_dynamic_color_preference", "feature_settings_dynamic_color_preference", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1062, 77),
      ))
    }

internal val Res.string.feature_settings_dynamic_color_yes: StringResource by lazy {
      StringResource("string:feature_settings_dynamic_color_yes", "feature_settings_dynamic_color_yes", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1140, 46),
      ))
    }

internal val Res.string.feature_settings_feedback: StringResource by lazy {
      StringResource("string:feature_settings_feedback", "feature_settings_feedback", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1187, 49),
      ))
    }

internal val Res.string.feature_settings_licenses: StringResource by lazy {
      StringResource("string:feature_settings_licenses", "feature_settings_licenses", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1237, 45),
      ))
    }

internal val Res.string.feature_settings_loading: StringResource by lazy {
      StringResource("string:feature_settings_loading", "feature_settings_loading", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1283, 48),
      ))
    }

internal val Res.string.feature_settings_logout: StringResource by lazy {
      StringResource("string:feature_settings_logout", "feature_settings_logout", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1661, 51),
      ))
    }

internal val Res.string.feature_settings_logout_cancel: StringResource by lazy {
      StringResource("string:feature_settings_logout_cancel", "feature_settings_logout_cancel", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1332, 50),
      ))
    }

internal val Res.string.feature_settings_logout_confirm_cta: StringResource by lazy {
      StringResource("string:feature_settings_logout_confirm_cta", "feature_settings_logout_confirm_cta", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1383, 63),
      ))
    }

internal val Res.string.feature_settings_logout_confirm_message: StringResource by lazy {
      StringResource("string:feature_settings_logout_confirm_message", "feature_settings_logout_confirm_message", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1447, 147),
      ))
    }

internal val Res.string.feature_settings_logout_confirm_title: StringResource by lazy {
      StringResource("string:feature_settings_logout_confirm_title", "feature_settings_logout_confirm_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1595, 65),
      ))
    }

internal val Res.string.feature_settings_notification_advance_15min: StringResource by lazy {
      StringResource("string:feature_settings_notification_advance_15min", "feature_settings_notification_advance_15min", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1713, 75),
      ))
    }

internal val Res.string.feature_settings_notification_advance_1d: StringResource by lazy {
      StringResource("string:feature_settings_notification_advance_1d", "feature_settings_notification_advance_1d", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1789, 64),
      ))
    }

internal val Res.string.feature_settings_notification_advance_1h: StringResource by lazy {
      StringResource("string:feature_settings_notification_advance_1h", "feature_settings_notification_advance_1h", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1854, 64),
      ))
    }

internal val Res.string.feature_settings_notification_advance_2h: StringResource by lazy {
      StringResource("string:feature_settings_notification_advance_2h", "feature_settings_notification_advance_2h", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1919, 68),
      ))
    }

internal val Res.string.feature_settings_notification_advance_30min: StringResource by lazy {
      StringResource("string:feature_settings_notification_advance_30min", "feature_settings_notification_advance_30min", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1988, 75),
      ))
    }

internal val Res.string.feature_settings_notification_day_friday: StringResource by lazy {
      StringResource("string:feature_settings_notification_day_friday", "feature_settings_notification_day_friday", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2064, 60),
      ))
    }

internal val Res.string.feature_settings_notification_day_monday: StringResource by lazy {
      StringResource("string:feature_settings_notification_day_monday", "feature_settings_notification_day_monday", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2125, 56),
      ))
    }

internal val Res.string.feature_settings_notification_day_saturday: StringResource by lazy {
      StringResource("string:feature_settings_notification_day_saturday", "feature_settings_notification_day_saturday", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2182, 62),
      ))
    }

internal val Res.string.feature_settings_notification_day_sunday: StringResource by lazy {
      StringResource("string:feature_settings_notification_day_sunday", "feature_settings_notification_day_sunday", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2245, 60),
      ))
    }

internal val Res.string.feature_settings_notification_day_thursday: StringResource by lazy {
      StringResource("string:feature_settings_notification_day_thursday", "feature_settings_notification_day_thursday", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2306, 58),
      ))
    }

internal val Res.string.feature_settings_notification_day_tuesday: StringResource by lazy {
      StringResource("string:feature_settings_notification_day_tuesday", "feature_settings_notification_day_tuesday", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2365, 57),
      ))
    }

internal val Res.string.feature_settings_notification_day_wednesday: StringResource by lazy {
      StringResource("string:feature_settings_notification_day_wednesday", "feature_settings_notification_day_wednesday", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2423, 67),
      ))
    }

internal val Res.string.feature_settings_notification_disabled_description: StringResource by lazy {
      StringResource("string:feature_settings_notification_disabled_description", "feature_settings_notification_disabled_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2491, 158),
      ))
    }

internal val Res.string.feature_settings_notification_disabled_title: StringResource by lazy {
      StringResource("string:feature_settings_notification_disabled_title", "feature_settings_notification_disabled_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2650, 88),
      ))
    }

internal val Res.string.feature_settings_notification_payment_day_label: StringResource by lazy {
      StringResource("string:feature_settings_notification_payment_day_label", "feature_settings_notification_payment_day_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2739, 83),
      ))
    }

internal val Res.string.feature_settings_notification_payment_description: StringResource by lazy {
      StringResource("string:feature_settings_notification_payment_description", "feature_settings_notification_payment_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2823, 173),
      ))
    }

internal val Res.string.feature_settings_notification_payment_time_label: StringResource by lazy {
      StringResource("string:feature_settings_notification_payment_time_label", "feature_settings_notification_payment_time_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2997, 84),
      ))
    }

internal val Res.string.feature_settings_notification_payment_title: StringResource by lazy {
      StringResource("string:feature_settings_notification_payment_title", "feature_settings_notification_payment_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3082, 79),
      ))
    }

internal val Res.string.feature_settings_notification_payment_toggle: StringResource by lazy {
      StringResource("string:feature_settings_notification_payment_toggle", "feature_settings_notification_payment_toggle", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3162, 92),
      ))
    }

internal val Res.string.feature_settings_notification_permission_description: StringResource by
    lazy {
      StringResource("string:feature_settings_notification_permission_description", "feature_settings_notification_permission_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3255, 196),
      ))
    }

internal val Res.string.feature_settings_notification_permission_enable: StringResource by lazy {
      StringResource("string:feature_settings_notification_permission_enable", "feature_settings_notification_permission_enable", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3452, 67),
      ))
    }

internal val Res.string.feature_settings_notification_permission_not_now: StringResource by lazy {
      StringResource("string:feature_settings_notification_permission_not_now", "feature_settings_notification_permission_not_now", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3520, 68),
      ))
    }

internal val Res.string.feature_settings_notification_permission_title: StringResource by lazy {
      StringResource("string:feature_settings_notification_permission_title", "feature_settings_notification_permission_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3589, 86),
      ))
    }

internal val Res.string.feature_settings_notification_session_advance_label: StringResource by
    lazy {
      StringResource("string:feature_settings_notification_session_advance_label", "feature_settings_notification_session_advance_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3676, 75),
      ))
    }

internal val Res.string.feature_settings_notification_session_description: StringResource by lazy {
      StringResource("string:feature_settings_notification_session_description", "feature_settings_notification_session_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3752, 217),
      ))
    }

internal val Res.string.feature_settings_notification_session_title: StringResource by lazy {
      StringResource("string:feature_settings_notification_session_title", "feature_settings_notification_session_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3970, 83),
      ))
    }

internal val Res.string.feature_settings_notification_session_toggle: StringResource by lazy {
      StringResource("string:feature_settings_notification_session_toggle", "feature_settings_notification_session_toggle", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4054, 96),
      ))
    }

internal val Res.string.feature_settings_notification_title: StringResource by lazy {
      StringResource("string:feature_settings_notification_title", "feature_settings_notification_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4151, 63),
      ))
    }

internal val Res.string.feature_settings_privacy_policy: StringResource by lazy {
      StringResource("string:feature_settings_privacy_policy", "feature_settings_privacy_policy", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4215, 71),
      ))
    }

internal val Res.string.feature_settings_reminders_error_load_failed: StringResource by lazy {
      StringResource("string:feature_settings_reminders_error_load_failed", "feature_settings_reminders_error_load_failed", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4287, 100),
      ))
    }

internal val Res.string.feature_settings_reminders_error_max_out_of_range: StringResource by lazy {
      StringResource("string:feature_settings_reminders_error_max_out_of_range", "feature_settings_reminders_error_max_out_of_range", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4388, 101),
      ))
    }

internal val Res.string.feature_settings_reminders_error_save_failed: StringResource by lazy {
      StringResource("string:feature_settings_reminders_error_save_failed", "feature_settings_reminders_error_save_failed", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4490, 100),
      ))
    }

internal val Res.string.feature_settings_reminders_error_schedule_empty: StringResource by lazy {
      StringResource("string:feature_settings_reminders_error_schedule_empty", "feature_settings_reminders_error_schedule_empty", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4591, 87),
      ))
    }

internal val Res.string.feature_settings_reminders_error_schedule_non_positive: StringResource by
    lazy {
      StringResource("string:feature_settings_reminders_error_schedule_non_positive", "feature_settings_reminders_error_schedule_non_positive", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4679, 102),
      ))
    }

internal val Res.string.feature_settings_reminders_insert_variable: StringResource by lazy {
      StringResource("string:feature_settings_reminders_insert_variable", "feature_settings_reminders_insert_variable", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4782, 74),
      ))
    }

internal val Res.string.feature_settings_reminders_max_label: StringResource by lazy {
      StringResource("string:feature_settings_reminders_max_label", "feature_settings_reminders_max_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4857, 92),
      ))
    }

internal val Res.string.feature_settings_reminders_save: StringResource by lazy {
      StringResource("string:feature_settings_reminders_save", "feature_settings_reminders_save", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5023, 51),
      ))
    }

internal val Res.string.feature_settings_reminders_saved: StringResource by lazy {
      StringResource("string:feature_settings_reminders_saved", "feature_settings_reminders_saved", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4950, 72),
      ))
    }

internal val Res.string.feature_settings_reminders_schedule_hint: StringResource by lazy {
      StringResource("string:feature_settings_reminders_schedule_hint", "feature_settings_reminders_schedule_hint", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5075, 64),
      ))
    }

internal val Res.string.feature_settings_reminders_schedule_label: StringResource by lazy {
      StringResource("string:feature_settings_reminders_schedule_label", "feature_settings_reminders_schedule_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5140, 101),
      ))
    }

internal val Res.string.feature_settings_reminders_template_hint: StringResource by lazy {
      StringResource("string:feature_settings_reminders_template_hint", "feature_settings_reminders_template_hint", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5242, 140),
      ))
    }

internal val Res.string.feature_settings_reminders_template_label: StringResource by lazy {
      StringResource("string:feature_settings_reminders_template_label", "feature_settings_reminders_template_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5383, 77),
      ))
    }

internal val Res.string.feature_settings_reminders_title: StringResource by lazy {
      StringResource("string:feature_settings_reminders_title", "feature_settings_reminders_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5461, 60),
      ))
    }

internal val Res.string.feature_settings_show_decimals: StringResource by lazy {
      StringResource("string:feature_settings_show_decimals", "feature_settings_show_decimals", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5522, 62),
      ))
    }

internal val Res.string.feature_settings_theme: StringResource by lazy {
      StringResource("string:feature_settings_theme", "feature_settings_theme", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5585, 38),
      ))
    }

internal val Res.string.feature_settings_thousands_separator: StringResource by lazy {
      StringResource("string:feature_settings_thousands_separator", "feature_settings_thousands_separator", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5624, 68),
      ))
    }

internal val Res.string.feature_settings_title: StringResource by lazy {
      StringResource("string:feature_settings_title", "feature_settings_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5693, 50),
      ))
    }

internal val Res.string.feature_settings_top_app_bar_action_icon_description: StringResource by
    lazy {
      StringResource("string:feature_settings_top_app_bar_action_icon_description", "feature_settings_top_app_bar_action_icon_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5744, 80),
      ))
    }

internal val Res.string.feature_settings_top_app_bar_navigation_icon_description: StringResource by
    lazy {
      StringResource("string:feature_settings_top_app_bar_navigation_icon_description", "feature_settings_top_app_bar_navigation_icon_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5825, 72),
      ))
    }

internal val Res.string.feature_settings_version: StringResource by lazy {
      StringResource("string:feature_settings_version", "feature_settings_version", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5898, 52),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("feature_settings_account_title", Res.string.feature_settings_account_title)
  map.put("feature_settings_brand_android", Res.string.feature_settings_brand_android)
  map.put("feature_settings_brand_default", Res.string.feature_settings_brand_default)
  map.put("feature_settings_brand_guidelines", Res.string.feature_settings_brand_guidelines)
  map.put("feature_settings_change_theme_placeholder_text", Res.string.feature_settings_change_theme_placeholder_text)
  map.put("feature_settings_change_theme_text", Res.string.feature_settings_change_theme_text)
  map.put("feature_settings_dark_mode_config_dark", Res.string.feature_settings_dark_mode_config_dark)
  map.put("feature_settings_dark_mode_config_light", Res.string.feature_settings_dark_mode_config_light)
  map.put("feature_settings_dark_mode_config_system_default", Res.string.feature_settings_dark_mode_config_system_default)
  map.put("feature_settings_dark_mode_preference", Res.string.feature_settings_dark_mode_preference)
  map.put("feature_settings_date_format", Res.string.feature_settings_date_format)
  map.put("feature_settings_date_format_dmy_dash", Res.string.feature_settings_date_format_dmy_dash)
  map.put("feature_settings_date_format_dmy_slash", Res.string.feature_settings_date_format_dmy_slash)
  map.put("feature_settings_date_format_ymd_dash", Res.string.feature_settings_date_format_ymd_dash)
  map.put("feature_settings_dismiss_dialog_button_text", Res.string.feature_settings_dismiss_dialog_button_text)
  map.put("feature_settings_display_title", Res.string.feature_settings_display_title)
  map.put("feature_settings_dynamic_color_no", Res.string.feature_settings_dynamic_color_no)
  map.put("feature_settings_dynamic_color_preference", Res.string.feature_settings_dynamic_color_preference)
  map.put("feature_settings_dynamic_color_yes", Res.string.feature_settings_dynamic_color_yes)
  map.put("feature_settings_feedback", Res.string.feature_settings_feedback)
  map.put("feature_settings_licenses", Res.string.feature_settings_licenses)
  map.put("feature_settings_loading", Res.string.feature_settings_loading)
  map.put("feature_settings_logout", Res.string.feature_settings_logout)
  map.put("feature_settings_logout_cancel", Res.string.feature_settings_logout_cancel)
  map.put("feature_settings_logout_confirm_cta", Res.string.feature_settings_logout_confirm_cta)
  map.put("feature_settings_logout_confirm_message", Res.string.feature_settings_logout_confirm_message)
  map.put("feature_settings_logout_confirm_title", Res.string.feature_settings_logout_confirm_title)
  map.put("feature_settings_notification_advance_15min", Res.string.feature_settings_notification_advance_15min)
  map.put("feature_settings_notification_advance_1d", Res.string.feature_settings_notification_advance_1d)
  map.put("feature_settings_notification_advance_1h", Res.string.feature_settings_notification_advance_1h)
  map.put("feature_settings_notification_advance_2h", Res.string.feature_settings_notification_advance_2h)
  map.put("feature_settings_notification_advance_30min", Res.string.feature_settings_notification_advance_30min)
  map.put("feature_settings_notification_day_friday", Res.string.feature_settings_notification_day_friday)
  map.put("feature_settings_notification_day_monday", Res.string.feature_settings_notification_day_monday)
  map.put("feature_settings_notification_day_saturday", Res.string.feature_settings_notification_day_saturday)
  map.put("feature_settings_notification_day_sunday", Res.string.feature_settings_notification_day_sunday)
  map.put("feature_settings_notification_day_thursday", Res.string.feature_settings_notification_day_thursday)
  map.put("feature_settings_notification_day_tuesday", Res.string.feature_settings_notification_day_tuesday)
  map.put("feature_settings_notification_day_wednesday", Res.string.feature_settings_notification_day_wednesday)
  map.put("feature_settings_notification_disabled_description", Res.string.feature_settings_notification_disabled_description)
  map.put("feature_settings_notification_disabled_title", Res.string.feature_settings_notification_disabled_title)
  map.put("feature_settings_notification_payment_day_label", Res.string.feature_settings_notification_payment_day_label)
  map.put("feature_settings_notification_payment_description", Res.string.feature_settings_notification_payment_description)
  map.put("feature_settings_notification_payment_time_label", Res.string.feature_settings_notification_payment_time_label)
  map.put("feature_settings_notification_payment_title", Res.string.feature_settings_notification_payment_title)
  map.put("feature_settings_notification_payment_toggle", Res.string.feature_settings_notification_payment_toggle)
  map.put("feature_settings_notification_permission_description", Res.string.feature_settings_notification_permission_description)
  map.put("feature_settings_notification_permission_enable", Res.string.feature_settings_notification_permission_enable)
  map.put("feature_settings_notification_permission_not_now", Res.string.feature_settings_notification_permission_not_now)
  map.put("feature_settings_notification_permission_title", Res.string.feature_settings_notification_permission_title)
  map.put("feature_settings_notification_session_advance_label", Res.string.feature_settings_notification_session_advance_label)
  map.put("feature_settings_notification_session_description", Res.string.feature_settings_notification_session_description)
  map.put("feature_settings_notification_session_title", Res.string.feature_settings_notification_session_title)
  map.put("feature_settings_notification_session_toggle", Res.string.feature_settings_notification_session_toggle)
  map.put("feature_settings_notification_title", Res.string.feature_settings_notification_title)
  map.put("feature_settings_privacy_policy", Res.string.feature_settings_privacy_policy)
  map.put("feature_settings_reminders_error_load_failed", Res.string.feature_settings_reminders_error_load_failed)
  map.put("feature_settings_reminders_error_max_out_of_range", Res.string.feature_settings_reminders_error_max_out_of_range)
  map.put("feature_settings_reminders_error_save_failed", Res.string.feature_settings_reminders_error_save_failed)
  map.put("feature_settings_reminders_error_schedule_empty", Res.string.feature_settings_reminders_error_schedule_empty)
  map.put("feature_settings_reminders_error_schedule_non_positive", Res.string.feature_settings_reminders_error_schedule_non_positive)
  map.put("feature_settings_reminders_insert_variable", Res.string.feature_settings_reminders_insert_variable)
  map.put("feature_settings_reminders_max_label", Res.string.feature_settings_reminders_max_label)
  map.put("feature_settings_reminders_save", Res.string.feature_settings_reminders_save)
  map.put("feature_settings_reminders_saved", Res.string.feature_settings_reminders_saved)
  map.put("feature_settings_reminders_schedule_hint", Res.string.feature_settings_reminders_schedule_hint)
  map.put("feature_settings_reminders_schedule_label", Res.string.feature_settings_reminders_schedule_label)
  map.put("feature_settings_reminders_template_hint", Res.string.feature_settings_reminders_template_hint)
  map.put("feature_settings_reminders_template_label", Res.string.feature_settings_reminders_template_label)
  map.put("feature_settings_reminders_title", Res.string.feature_settings_reminders_title)
  map.put("feature_settings_show_decimals", Res.string.feature_settings_show_decimals)
  map.put("feature_settings_theme", Res.string.feature_settings_theme)
  map.put("feature_settings_thousands_separator", Res.string.feature_settings_thousands_separator)
  map.put("feature_settings_title", Res.string.feature_settings_title)
  map.put("feature_settings_top_app_bar_action_icon_description", Res.string.feature_settings_top_app_bar_action_icon_description)
  map.put("feature_settings_top_app_bar_navigation_icon_description", Res.string.feature_settings_top_app_bar_navigation_icon_description)
  map.put("feature_settings_version", Res.string.feature_settings_version)
}
